var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"detail d-flex justify-content-center align-items-center"},[_c('div',{staticClass:"ipsum"},[_c('p',{staticClass:"mb-0"},[_vm._v("Lorium ipsum dolor sit amet")]),_vm._v(" "),_c('h2',{staticClass:"text-center mb-0"},[_vm._v("Blog Details")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-477377e0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page5/banner.vue
// module id = 674
// module chunks = 0